import React from "react";
import SectionBgImg from "./SectionBgImg";
import { useRecoilState, useRecoilValueLoadable } from "recoil";
import { detailedResultState, resultSelector } from "../../../utils/recoil";
import { useTranslation } from "react-i18next";

/**
 * Always use the *English* MBTI keys for dynamic value lookup,
 * but allow trait labels to be translated.
 */
const DEFAULT_TRAIT_PAIRS = [
  ["INTROVERT", "EXTROVERT"],
  ["SENSING", "INTUITION"],
  ["THINKING", "FEELING"],
  ["JUDGING", "PROSPECTING"],
];

const getResultItem = (result) => (Array.isArray(result) ? result[0] : result);

const ResultCard = ({ resultOverride }) => {
  const [data] = useRecoilState(detailedResultState);
  const resultLoadable = useRecoilValueLoadable(resultSelector);
  const result =
    resultOverride ??
    (resultLoadable.state === "hasValue" ? resultLoadable.contents : undefined);
  const resultItem = getResultItem(result);

  const { t } = useTranslation("result");
  // Always use English keys for MBTI (even for other languages)
  const traitPairsEn = DEFAULT_TRAIT_PAIRS;

  return (
    <div className="px-[7rem] md-max:px-[1rem] flex flex-col md-max:gap-4 relative md-max:hidden">
      <SectionBgImg />
      <p className="text-3xl font-bold -translate-y-full md-max:translate-y-0 md-max:mt-4">{t("pdfResultCard.title")}</p>
      <div className="bg-[#F1F7FF] shadow-xl z-10 relative rounded-xl py-9 px-14 flex justify-between">
        <div className="flex items-center gap-6 w-1/3">
          <img
            src={data?.image_urls ?? "/top-card-char.webp"}
            alt="character"
            className="w-28 h-28 rounded-full overflow-hidden object-cover"
          />
          <div className="flex flex-col">
            <p className="font-semibold text-xl text-center">{data?.name}</p>
            {/* <p className="text-xl">ENFP-A</p> */}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-8 w-2/3">
          {resultItem?.prediction?.mbti?.values &&
            traitPairsEn.map(([leftTrait, rightTrait], index) => {
              // Get value using English keys
              const leftValue = parseFloat(resultItem?.prediction?.mbti?.values[leftTrait]);
              const rightValue = parseFloat(resultItem?.prediction?.mbti?.values[rightTrait]);
              // Labels (translated if possible)
              const traitPairsTranslated = t("pdfResultCard.traits", { returnObjects: true });
              // Fallback to English if translation missing
              let leftLabel = leftTrait, rightLabel = rightTrait;
              if (
                Array.isArray(traitPairsTranslated) &&
                Array.isArray(traitPairsTranslated[index])
              ) {
                leftLabel = traitPairsTranslated[index][0];
                rightLabel = traitPairsTranslated[index][1];
              }
              return (
                <div key={leftTrait + "-" + rightTrait}>
                  <progress
                    value={leftValue}
                    max="100"
                    className="h-3 w-full appearance-none rounded-full bg-primary-blue [&::-moz-progress-bar]:rounded-full [&::-moz-progress-bar]:bg-gray-200 [&::-webkit-progress-bar]:rounded-full [&::-webkit-progress-bar]:bg-gray-200 [&::-webkit-progress-value]:rounded-full [&::-webkit-progress-value]:bg-primary-blue [&::-moz-progress-value]:rounded-full"
                  >
                    {leftValue}%
                  </progress>
                  <div className="flex justify-between w-full">
                    <div className="flex flex-col">
                      <p>{leftValue}%</p>
                      <p>
                        {leftLabel.charAt(0) + leftLabel.slice(1).toLowerCase()}
                      </p>
                    </div>
                    <div className="flex flex-col items-end">
                      <p>{rightValue}%</p>
                      <p>
                        {rightLabel.charAt(0) + rightLabel.slice(1).toLowerCase()}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {/* <p className="text-xl py-12">
        {data?.simple_desc}
      </p> */}
    </div>
  );
};

export default ResultCard;
